<div class="siteOptionsExportModal__infoWrapper">
  <div class="siteOptionsExportModal__info">
    <pp-icon ppClass="setSize14" [ppSrc]="EIconPath.ICON_BADGE_INFO" ppColor="grey-600"></pp-icon>
    {{ 'point_csv_export_note' | ppTranslate }}
  </div>
</div>
